import React from "react"

import {
  WrapperLight,
  Inner,
  Dots,
  Dot,
  Row,
  Col12,
  Heading3,
  Heading1Daintree,
} from "../../styles/styles"

const Section1 = () => (
  <WrapperLight>
    <Inner>
      <Row>
        <Col12>
          <Heading3>Round 2.</Heading3>
          <Heading1Daintree>ALL THE APPLICATIONS ARE BELONG TO US.</Heading1Daintree>
          <Dots>
            <Dot style={{ backgroundColor: `white` }} />
            <Dot />
            <Dot />
          </Dots>
        </Col12>
      </Row>
    </Inner>
  </WrapperLight>
)

export default Section1
